import { render, staticRenderFns } from "./DrivingLicenseIndex.vue?vue&type=template&id=2401e9b9&"
import script from "./DrivingLicenseIndex.vue?vue&type=script&lang=js&"
export * from "./DrivingLicenseIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports